var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMintButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 60,
    viewBox: "0 0 180 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.273 30L148.434 59.236L147.855 58.6869V59.5H140.72L139.544 58.4517L139.36 58.2879L139.118 58.3337L132.967 59.5H76.4123L74.4521 57.2468L73.5863 57.6813L73.9819 59.5H32.2507V58.587L31.5661 59.236L0.726754 30L31.5661 0.763969L32.2507 1.41297V0.5H32.4439L35.6505 1.78892L35.9578 1.91244L36.1914 1.67769L37.3633 0.5H112.313H114.159H147.855V1.31309L148.434 0.763998L179.273 30Z",
    fill: "url(#paint0_linear_2151_82)",
    stroke: "url(#paint1_linear_2151_82)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2151_82",
    x1: 68.9285,
    y1: 64,
    x2: 68.2538,
    y2: -1.9772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#2E0200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1817"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2151_82",
    x1: 118.931,
    y1: -193.856,
    x2: 96.3702,
    y2: 106.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDDBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477083,
    stopColor: "#FFEA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#693E18"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintButton);
export default __webpack_public_path__ + "static/media/Mint-button.cff0b424972629409901a612a242739b.svg";
export { ForwardRef as ReactComponent };